const routes = {
  shifts: 'Horas de la escuela',
  passengers: 'Alumnos'
};

export default routes;
